// extracted by mini-css-extract-plugin
export default {"container":"cards-row_container__TCrmT"};